export default {
  ControlGroupFor: 'data-control-group-for',
};
